<div class="lvi-content">
    <div class="avatar" [nSelector]="{liste: liste, item: data}">
        <i class="material-icons-outlined">{{ getIconeFromNatureVoyage(data.codeFamille) }}</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="onItemClick()">{{ data.libelle }}</a>
        </div>
        <ul class="lvi-attrs">
            <li><strong [translate]="'admin.frais.typesCharges.tooltip.code'"></strong> {{ data.code }} </li>
            <li *ngIf="data.idTypeFile !== 0"><strong [translate]="'admin.frais.typesCharges.tooltip.formatImport'"></strong> {{ typesChargesService.getLibelleTypeFileById(data.idTypeFile) }} </li>
        </ul>
    </div>
</div>